import * as actionTypes from './actionTypes';
const getReportsLabels = () => (sessionStorage.getItem('lng') === 'fr'
  ? require('./../../labels/labels.french.json')
  : require('./../../labels/labels.json')).REPORTS;
const initialState = {
  reportsList: [],
  isFetching: false,
  error: { reportsListError: false, message: '' }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REPORTSLIST_REQUEST:
      return { ...state, reportsList: [], isFetching: true };
    case actionTypes.FETCH_REPORTSLIST_SUCCESS:
      return { ...state, reportsList: action.data, isFetching: false };
    case actionTypes.FETCH_REPORTSLIST_FAILURE:
      return {
        ...state,
        reportsList: [],
        isFetching: false,
        error: {
          reportsListError: true,
          message: getReportsLabels().REPORTS_FAILED
        }
      };
    default:
      return state;
  }
};

export { reducer as default };
